import styled from "styled-components";

export const MainBodyStyle = styled.div`
  margin-top: 10vh;
  padding: 20px;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
`;

export const MainStyles = styled.div`
  padding: 20px; /* add some padding */
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const PageStyle = styled.div`
  .home-container {
    display: flex; /* use flexbox to create two columns */
    flex-direction: column;
    font-family: medium-pro, sans-serif;
    padding: 20px;
    margin-left: 30%;
    min-height: 100vh;
  }
  .home-container2 {
    display: flex; /* use flexbox to create two columns */
    flex-direction: column;
    font-family: medium-pro, sans-serif;
    padding: 20px;
    min-height: 100vh;
  }
  .main2 {
    padding-top: 20px; /* add some padding */
    padding-bottom: 20px; /* add some padding */
    width: 70%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-self: center;
    align-items: center;
  }

  .main {
    padding-top: 20px; /* add some padding */
    padding-bottom: 20px; /* add some padding */
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  /* For large devices */
  @media screen and (max-width: 2560px) {
    .home-container {
      margin-left: 22%;
    }
  }
  @media screen and (max-width: 1440px) {
    .home-container {
      margin-left: 30%;
    }
  }
  @media screen and (max-width: 1024px) {
    .home-container {
      margin-left: 30%;
    }
  }

  /* For medium devices */
  @media screen and (max-width: 800px) {
    .home-container {
      margin-left: 0%;
    }
  }

  @media only screen and (max-width: 450px) {
    .home-container {
      margin-left: 0%;
    }
  }
`;
